import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import payrollService from '../services/payrollService';
import PayrollForm from '../components/PayrollForm';
import { useNotification } from '../context/NotificationContext';
import '../styles/general.css';

// A payroll in one of these is frozen; the editor would be a dead end.
const LOCKED_STATUSES = ['pagado', 'cancelado'];

const PayrollFormPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const { notify } = useNotification();
  const isEditMode = !!id;

  const [payroll, setPayroll] = useState(null);
  const [loading, setLoading] = useState(isEditMode);

  useEffect(() => {
    if (!isEditMode) return;

    const fetchPayroll = async () => {
      try {
        const res = await payrollService.getPayrollById(id);
        setPayroll(res.data);
      } catch (err) {
        console.error('Error loading payroll:', err);
        notify.error(t('payroll.failedToLoad'));
      } finally {
        setLoading(false);
      }
    };
    fetchPayroll();
  }, [id, isEditMode, t, notify]);

  if (loading) {
    return <div className="loading">{t('common.loading')}</div>;
  }

  // The backend rejects writes to a paid or cancelled payroll, so send the
  // user to the read-only view instead of letting them fill in a form that
  // can only fail on save.
  if (isEditMode && payroll && LOCKED_STATUSES.includes(payroll.status)) {
    return <Navigate to={`/payroll/${payroll.id}`} replace />;
  }

  return (
    <div className="page-container-wide">
      {/* The employee name and period live in the form's right-hand summary
          panel, per the spec; repeating them in a header badge would show the
          same two values twice on one screen. */}
      <div className="page-header">
        <h1>{t('payroll.title')}</h1>
      </div>

      <PayrollForm
        initialData={payroll}
        onSuccess={() => navigate('/payroll')}
        onCancel={() => navigate('/payroll')}
      />
    </div>
  );
};

export default PayrollFormPage;
